
import { toast } from "sonner";
import { JOURNEYS_STORAGE_KEY, FOLDERS_STORAGE_KEY } from "./constants";
import { SavedJourney, Folder } from "./types";

// Retrieve all saved journeys from localStorage
export const getSavedJourneys = (): SavedJourney[] => {
  try {
    const savedData = localStorage.getItem(JOURNEYS_STORAGE_KEY);
    if (!savedData) return [];
    
    const journeys = JSON.parse(savedData);
    
    // Handle legacy journeys without folderId
    return journeys.map((journey: any) => ({
      ...journey,
      folderId: journey.folderId || null
    }));
  } catch (error) {
    console.error("Error loading saved journeys:", error);
    toast.error("Failed to load saved journeys");
    return [];
  }
};

// Retrieve all folders from localStorage
export const getFolders = (): Folder[] => {
  try {
    const savedData = localStorage.getItem(FOLDERS_STORAGE_KEY);
    if (!savedData) return [];
    
    return JSON.parse(savedData) as Folder[];
  } catch (error) {
    console.error("Error loading folders:", error);
    toast.error("Failed to load folders");
    return [];
  }
};

// Save the given journeys to localStorage
export const saveJourneys = (journeys: SavedJourney[]): boolean => {
  try {
    localStorage.setItem(JOURNEYS_STORAGE_KEY, JSON.stringify(journeys));
    return true;
  } catch (error) {
    console.error("Error saving journeys:", error);
    toast.error("Failed to save journeys");
    return false;
  }
};

// Save the given folders to localStorage
export const saveFolders = (folders: Folder[]): boolean => {
  try {
    localStorage.setItem(FOLDERS_STORAGE_KEY, JSON.stringify(folders));
    return true;
  } catch (error) {
    console.error("Error saving folders:", error);
    toast.error("Failed to save folders");
    return false;
  }
};
